import React from "react";

const IconBasket = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_basket_light"
      data-name="UI icon/basket/light"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="Union"
        d="M10.837,14H3.163a2.162,2.162,0,0,1-2.111-1.881L.007,4.61a.744.744,0,0,1,.167-.582.7.7,0,0,1,.537-.252H2.44L5.492.641a2.094,2.094,0,0,1,3.016,0L11.56,3.776h1.729a.7.7,0,0,1,.537.252.743.743,0,0,1,.166.581l-1.044,7.509A2.163,2.163,0,0,1,10.837,14ZM1.53,5.237l.928,6.676a.722.722,0,0,0,.7.627h7.675a.721.721,0,0,0,.7-.627l.928-6.676ZM7,1.461a.7.7,0,0,0-.5.214l-2.047,2.1h5.1L7.5,1.674A.7.7,0,0,0,7,1.461Z"
        transform="translate(0 0)"
        fill={color}
      />
      <path
        id="Vector_606_Stroke_"
        data-name="Vector 606 (Stroke)"
        d="M.711,0a.721.721,0,0,1,.711.73V3.651a.721.721,0,0,1-.711.73A.721.721,0,0,1,0,3.651V.73A.721.721,0,0,1,.711,0Z"
        transform="translate(3.446 6.697)"
        fill={color}
      />
      <path
        id="Vector_607_Stroke_"
        data-name="Vector 607 (Stroke)"
        d="M.711,0a.721.721,0,0,1,.711.73V3.651a.721.721,0,0,1-.711.73A.721.721,0,0,1,0,3.651V.73A.721.721,0,0,1,.711,0Z"
        transform="translate(6.289 6.697)"
        fill={color}
      />
      <path
        id="Vector_608_Stroke_"
        data-name="Vector 608 (Stroke)"
        d="M.711,0a.721.721,0,0,1,.711.73V3.651a.721.721,0,0,1-.711.73A.721.721,0,0,1,0,3.651V.73A.721.721,0,0,1,.711,0Z"
        transform="translate(9.133 6.697)"
        fill={color}
      />
    </svg>
  );
};

export default IconBasket;
